/* Alia v3.8.77 names its host by flowID and marks its full dialog aria-modal.
 * Keep the original offer button and app handlers; dock only this flow's tab. */
(() => {
  const slot = document.querySelector('[data-tsf-home-offer-slot]');
  if (!slot || !document.body.classList.contains('tsf-homepage')) return;

  let root;
  let frame;
  const schedule = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = undefined;
      settle();
    });
  };
  const rootObserver = new MutationObserver(schedule);

  const move = (parent) => {
    if (root.parentElement === parent) return;
    const focused = root.contains(document.activeElement) ? document.activeElement : null;
    parent.appendChild(root);
    if (focused) focused.focus({ preventScroll: true });
  };

  function settle() {
    const candidate = document.getElementById('alia-root-352330');
    if (candidate !== root) {
      rootObserver.disconnect();
      root = candidate;
      if (root) rootObserver.observe(root, {
        attributes: true, attributeFilter: ['aria-modal', 'style'],
        childList: true, subtree: true,
      });
    }
    if (!root) {
      slot.hidden = true;
      return;
    }
    const content = root.shadowRoot || root;
    const dock = root.getAttribute('aria-modal') !== 'true'
      && Boolean(content.querySelector('button'));
    if (dock) {
      root.setAttribute('data-tsf-offer-docked', '');
      move(slot);
      slot.hidden = root.style.display === 'none';
    } else {
      root.removeAttribute('data-tsf-offer-docked');
      move(document.body);
      slot.hidden = true;
    }
  }

  // The app mounts asynchronously and can replace its host after navigation.
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  settle();
})();
